let state = {
    inited: false,
    status: 0,  // 是否打过卡，0：未打卡；1：已打卡；2：无可用
    // share_id: '',
    question: [],  // 问答
    question_pages: 0,  //问答总页数
    storys: [], // 跟读、阅读
    storys_pages: 0, //跟读、阅读总页数
    // demo_audio: '',
    period_id: 0, //阶段
    day_id: 0, //天数
    total_days: 0, //总天数
    // series_day: 0, //连续的天数
    // during: 0, //音频时间  以秒为单位
    cover_img: '',
    cover_title: '',
    cover_text: '',
    cover_audio: '',
    // user_weixin_audio: '', // 录音的serverId
    // training: {}, // 打卡信息
    // loves: '', // 点赞数
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/habitCardPrev/state.js